module.exports = __webpack_public_path__ + "static/media/404-page-04.329f6fd3.png";